import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/marketing";

const STATUS_STYLE = { SIMULATED: "bg-amber-50 text-amber-700", SENT: "bg-green-50 text-green-700", FAILED: "bg-red-50 text-red-700", QUEUED: "bg-gray-100 text-gray-600" };

export const EmailLogDialog = ({ item, onClose }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/marketing/email-log", { params: { content_id: item.id } }).then((r) => setData(r.data));
  }, [item.id]);
  const c = item.notification?.counts;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="email-log-dialog">
      <div className="bg-white rounded-[12px] w-full max-w-3xl max-h-[85vh] overflow-y-auto p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold text-[#0A0A0A]">Notifiche · {item.title}</h3>
          <button onClick={onClose} data-testid="email-log-close"><X size={18} /></button>
        </div>
        {data?.mode === "simulated" && (
          <p className="text-xs font-semibold bg-amber-50 text-amber-800 rounded-[8px] p-3" data-testid="email-log-simulated-banner">
            Modalità SIMULATA: nessuna email è stata consegnata. Le righe registrano solo l'invio previsto.
          </p>
        )}
        {c && (
          <p className="text-sm text-gray-600" data-testid="email-log-counts">
            Simulate {c.simulated} · Inviate {c.sent} · Fallite {c.failed} · Escluse {c.excluded} · Duplicati bloccati {c.duplicate}
          </p>
        )}
        {data && data.total > data.items.length && <p className="text-xs text-gray-500" data-testid="email-log-truncated">Mostrate le ultime {data.items.length} di {data.total} righe.</p>}
        {!data ? <p className="text-gray-400 text-sm">Caricamento…</p> : data.items.length === 0 ? (
          <p className="text-sm text-gray-500" data-testid="email-log-empty">Nessuna notifica registrata.</p>
        ) : (
          <table className="w-full text-sm" data-testid="email-log-table">
            <thead><tr className="text-left text-xs uppercase text-gray-400"><th className="py-2">Destinatario</th><th>Evento</th><th>Data</th><th>Stato</th></tr></thead>
            <tbody>
              {data.items.map((r) => (
                <tr key={r.id} className="border-t border-gray-100">
                  <td className="py-2 truncate max-w-[220px]">{r.to}</td>
                  <td className="text-xs text-gray-500">{r.trigger}</td>
                  <td className="text-xs text-gray-500">{fmtDate(r.created_at)}</td>
                  <td><span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${STATUS_STYLE[r.status] || ""}`}>{r.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
